import Rate from "rc-rate";
import { useIntl } from "react-intl";

import { ImStarFull } from "react-icons/im";

import "./Rating.scss";
import "rc-rate/assets/index.css";

export interface RatingProps {
  point?: string;
  quantity?: string;
}
export function Rating({ point, quantity }: RatingProps) {
    const { formatMessage } = useIntl();
  
  return (
    <div className="rate">
      <Rate
        character={() => (
          <ImStarFull fill="#b4bcc9" strokeWidth="0.5" stroke="#A7B0BE" />
        )}
        className="rate-rc"
        allowHalf
      />
      <p className="rate-point">{point}</p>
      <p className="rate-quantity">{quantity} {formatMessage({
                id: "doctors.card.rate",
                defaultMessage: "_Rate_",
              })}</p>
    </div>
  );
}
